module.exports = __webpack_public_path__ + "img/tab-lottery-inactive.3f840b34.png";